import { createContext } from 'react';
import {
    Etablissement,
    PayBudget,
} from 'routes/HumanResourcesModule/PayState/helpers/types';

export const OrgChartHrContext: React.Context<TreeT> = createContext<TreeT>({
    label: '',
    value: '',
    id: 0,
    children: [],
});
export const EtablissementAndPayBudgetContext: React.Context<{
    payBudget: PayBudget[];
    etablissement: Etablissement[];
}> = createContext<{
    payBudget: PayBudget[];
    etablissement: Etablissement[];
}>({
    payBudget: [],
    etablissement: [],
});
